import client from './client';

export const contentPackagesApi = {
  list: (params) => client.get('/content-packages', { params }).then((r) => r.data),
  get: (id) => client.get(`/content-packages/${id}`).then((r) => r.data),
  create: (payload) => client.post('/content-packages', payload).then((r) => r.data),
  update: (id, payload) =>
    client.put(`/content-packages/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/content-packages/${id}`).then((r) => r.data),
  generate: (id, payload) =>
    client.post(`/content-packages/${id}/generate`, payload).then((r) => r.data),
  // Create a package and persist its already-generated posts in one call.
  saveWithPosts: (payload) =>
    client.post('/content-packages/save-with-posts', payload).then((r) => r.data),
  // Get the active posting schedule for a business (null if not set yet).
  businessSchedule: (businessId) =>
    client.get('/content-packages/business-schedule', { params: { business_id: businessId } }).then((r) => r.data),
  // Assign a package to a business and auto-schedule its posts. Pass `schedule`
  // only when the business has no posting schedule yet.
  assignBusiness: (id, payload) =>
    client.post(`/content-packages/${id}/assign-business`, payload).then((r) => r.data),
  // Edit a reusable template post inside a package.
  updatePost: (packageId, postId, payload) =>
    client.put(`/content-packages/${packageId}/posts/${postId}`, payload).then((r) => r.data),
  deletePost: (packageId, postId) =>
    client.delete(`/content-packages/${packageId}/posts/${postId}`).then((r) => r.data),
  // Add a reusable template post to a package (blank, AI, or CSV import).
  addPost: (packageId, payload) =>
    client.post(`/content-packages/${packageId}/posts`, payload).then((r) => r.data),
  // Persist a new ordering of the package's posts.
  reorderPosts: (packageId, ids) =>
    client.post(`/content-packages/${packageId}/posts/reorder`, { ids }).then((r) => r.data),
  // Delete several package posts at once.
  bulkDeletePosts: (packageId, ids) =>
    client.post(`/content-packages/${packageId}/posts/bulk-delete`, { ids }).then((r) => r.data),
};

export default contentPackagesApi;
